/* eslint no-underscore-dangle: 0 */
import React from 'react';
import { connect } from 'react-redux';
import { create } from '~/actions/orderNew';
import { create as createContainer } from '~/actions/containers';
import { move2 } from '~/actions/articles';
import { move2 as move2RawMaterial } from '~/actions/rawMaterial';
import LocationPicker from '~/components/LocationPicker';
import DatePicker from '~/components/DatePicker';
import ArticlePicker from '~/components/ArticlePicker';
import RawMaterialPicker from '~/components/RawMaterialPicker';
import MultiPickerCount from '~/components/MultiPickerCount';
import { Button } from 'react-toolbox/lib/button';
import Title from '~/components/Title';

import style from './style.scss';

const MultiArticlePicker = MultiPickerCount(ArticlePicker);
const MultiRawMaterialPicker = MultiPickerCount(RawMaterialPicker);

class Import3DCartPage extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired,
    router: React.PropTypes.object.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      reference: '',
      notes: '',
      locationId: null,
      eta: null,
      articleIds: {},
      rawMaterialIds: {},
      locationFrom: null,
    };
  }

  createDelivery() {
    if (!this.state.locationId) {
      return this.context.dialogPush('message', { content: 'Oops', subContent: 'No container-location selected' });
    }
    if (!this.state.locationFrom) {
      return this.context.dialogPush('message', { content: 'Oops', subContent: 'No from-location selected' });
    }
    create(
      this.props.dispatch,
      this.context.apiClient,
      { reference: this.state.reference, notes: this.state.notes },
    ).then(r => createContainer(
      this.props.dispatch,
      this.context.apiClient,
      {
        orderId: r.data.id,
        locationId: this.state.locationId,
        eta: this.state.eta,
        articleIds: this.state.articleIds,
        rawMaterialIds: this.state.rawMaterialIds,
      },
    )).then(r => {
      move2(
        this.props.dispatch,
        this.context.apiClient,
        this.state.articleIds,
        { type: 'location', id: this.state.locationFrom },
        { type: 'container', id: r.data.id },
      ).then(() => move2RawMaterial(
        this.props.dispatch,
        this.context.apiClient,
        this.state.rawMaterialIds,
        { type: 'location', id: this.state.locationFrom },
        { type: 'container', id: r.data.id },
      )).then(() => this.context.dialogPush(
        'container',
        { id: r.data.id }
      ));
    });
    return true;
  }

  navigate(url) {
    this.context.router.history.push(url);
  }

  render() {
    return (
      <div style={{ padding: '10px' }}>
        <form onSubmit={e => { e.preventDefault(); this.createDelivery(); }}>
          <Title style={{ marginBottom: '10px' }}>Register a incoming delivery</Title>
          <div className={style.input}>
            <div>Enter delivery reference</div>
            <input
              required
              onChange={e => this.setState({ reference: e.target.value })}
              value={this.state.reference}
            />
          </div>
          <div className={style.input}>
            <div>Notes</div>
            <textarea
              onChange={e => this.setState({ notes: e.target.value })}
              value={this.state.notes}
            />
          </div>
          <div className={style.input}>
            <div>What location should it be placed in?</div>
            <LocationPicker
              required
              onChange={locationId => this.setState({ locationId })}
              value={this.state.locationId}
            />
          </div>
          <div className={style.input}>
            <div>Delivery ETA</div>
            <DatePicker
              onChange={eta => this.setState({ eta })}
              value={this.state.eta}
            />
          </div>
          <div className={style.input}>
            <div>What location does the items come from? (external location)</div>
            <LocationPicker
              required
              onChange={locationFrom => this.setState({ locationFrom })}
              value={this.state.locationFrom}
            />
          </div>
          <div className={style.input}>
            <div>Articles</div>
            <MultiArticlePicker
              onChange={articleIds => this.setState({ articleIds })}
              value={this.state.articleIds}
            />
          </div>
          <div className={style.input}>
            <div>Raw Materials</div>
            <MultiRawMaterialPicker
              onChange={rawMaterialIds => this.setState({ rawMaterialIds })}
              value={this.state.rawMaterialIds}
            />
          </div>
          <Button type="submit" label="Create incoming delivery" primary raised icon="done" />
        </form>
      </div>
    );
  }
}

export default connect()(Import3DCartPage);



// WEBPACK FOOTER //
// ./app/pages/IncomingDelivery/index.js